import { render, staticRenderFns } from "./profileWeb.vue?vue&type=template&id=7a2483b7"
import script from "./profile.js?vue&type=script&lang=js&external"
export * from "./profile.js?vue&type=script&lang=js&external"
import style0 from "./profileWeb.vue?vue&type=style&index=0&id=7a2483b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports